;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('ArtsService', artsService)

  /* @ngInject */
  function artsService (ConnectorWebService, CONSTANTS, $translate, Utils, MessageService, UploadService, CustomerCompanyService) {
    const service = {
      getArtSettings,
      groupTemplateByProduct,
      getArchivedArts,
      archiveArt,
      unarchiveArt,
      getArtThumbnailUrl,
      getArtFonts,
      getSharedArts,
      addArtCollaborator,
      addCommentToArt,
      sendArtToApproval,
      approveArt,
      rejectArt,
      disapproveArt,
      sendArtToDesiging,
      getArtCollaborators,
      deleteArtCollaborator,
      resendEmailArtCollaborator,
      getArts,
      getArtsApprovals,
      deleteArt,
      findLayersId,
      getArtDetailById,
      updateArtById,
      deleteArts,
      getUserFolders,
      createFolder,
      updateFolder,
      deleteFolder,
      setArtsFolder,
      removeArtsFromFolder,
      cloneArt,
      getArtCategoriesByProduct,
      getArtApprovalComments,
      getArtApprovalHistory,
      getUserTemplates,
      getCompanyTemplates,
      deleteArtLayer,
      search,
      formatApprovalStatusText,
      renderArt,
      downloadArt,
      updateArtSize,
      updateComment,
      deleteComment,
      getArtPins,
      getSocialSharingLog,
      bulkArchiveTemplates,
      bulkUnarchiveTemplates,
      bulkUpdateTemplates,
      getBusinessDataByArt,
      canShareArt,
      archiveTemplatesByCampaign,
      unarchiveTemplatesByCampaign,
      getPhotoframesByArtAndId,
      getPhotoframeAssets,
      preventUploadWebp,
      uploadAssets,
      getPhotoframesCount,
      updateArtSection,
      getHyperlinksByArt,
      getInfosBusinessData,
      updateTemporarilyAvailableArt,
      getPhotoframeAssetsCountByCategory,
      getDefaultAssetsForPhotoframe,
      updateArtSettings,
      uploadTemplates,
      getMultipleArtsSettings,
      copyArtUrlToClipboard,
      bindTemplateToCampaign,
      unbindTemplateFromCampaign,
      getRecentTemplates,
      batchDownloadMaterials,
      batchRenderMaterials
    }

    return service

    function groupTemplateByProduct (aTemplates) {
      var templateByProduct = aTemplates.reduce(function (agg, template) {
        var product = agg.filter(function (item) {
          return item.id === template.productId
        })[0]

        if (!product) {
          var newProduct = {
            id: template.productId,
            name: template.productTitle,
            templates: []
          }
          product = newProduct

          agg.push(newProduct)
        }

        product.templates.push(template)

        return agg
      }, [])

      return templateByProduct.map(({ name, templates }) => [{ name }, ...templates]).flat(1)
    }

    function getArchivedArts (top, skip) {
      var sUrl = CONSTANTS.URL_ARCHIVED_ARTS

      if (top || skip) {
        sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, top, skip)
      }

      return ConnectorWebService.get(sUrl)
    }

    function archiveArt (sArtId) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARCHIVE_ART, [sArtId])

      if (window.__DeskfyObserver__) {
        window.__DeskfyObserver__['archived-template'] = sArtId
      }

      return ConnectorWebService.put(sUrl, {})
    }

    function unarchiveArt (sArtId, turnArtsAvailable = false) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_DISARCHIVE_ART, [sArtId])
      return ConnectorWebService.put(sUrl, { turnArtsAvailable })
    }

    function getArtFonts (id) {
      if (!id) {
        return
      }
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID_FONTS, [id])
      return ConnectorWebService.get(sUrl)
    }

    function getSharedArts (top, skip) {
      var sUrl = CONSTANTS.URL_SHARED_ARTS

      if (top || skip) {
        sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, top, skip)
      }

      return ConnectorWebService.get(sUrl)
    }

    /**
    * add collaborator
    * @param {String} sArtId
    * @param {Object} oCollaborator
    * @param {String} oCollaborator.email
    * @param {boolean} oCollaborator.sendNotification
    */
    function addArtCollaborator (sArtId, oCollaborator) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ART, [sArtId])
      return ConnectorWebService.post(sUrl, oCollaborator)
    }

    /**
    * Add an approval comment to an art
    * @param {String} sArtId
    * @param {Object} oPayload
    * @param {String} oPayload.message
    */
    function addCommentToArt (sArtId, oPayload) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_APPROVAL_COMMENTS, [sArtId])
      return ConnectorWebService.post(sUrl, oPayload)
    }

    /**
    * Send art to be approved
    * @param {String} sArtId
    * @param {Object} oPayload
    * @param {String} oPayload.message
    */
    function sendArtToApproval (sArtId, oPayload) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_SEND_TO_APPROVAL, [sArtId])
      return ConnectorWebService.post(sUrl, oPayload)
    }

    /**
    * Approve art
    * @param {String} sArtId
    * @param {Object} oPayload
    * @param {String} oPayload.message
    */
    function approveArt (sArtId, oPayload) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_APPROVE, [sArtId])
      return ConnectorWebService.post(sUrl, oPayload)
    }

    /**
    * Disapprove art
    * @param {String} sArtId
    * @param {Object} oPayload
    * @param {String} oPayload.message
    */
    function disapproveArt (sArtId, oPayload) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DISAPPROVE, [sArtId])
      return ConnectorWebService.post(sUrl, oPayload)
    }

    /**
    * Disapprove art
    * @param {String} sArtId
    * @param {Object} oPayload
    * @param {String} oPayload.message
    */
    function rejectArt (sArtId, oPayload) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_REJECT, [sArtId])
      return ConnectorWebService.post(sUrl, oPayload)
    }

    /**
    * Send art to be approved
    * @param {String} sArtId
    */
    function sendArtToDesiging (sArtId) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_SEND_TO_DESIGNING, [sArtId])
      return ConnectorWebService.post(sUrl, {})
    }

    function getArtCollaborators (sArtId) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ART, [sArtId])
      return ConnectorWebService.get(sUrl)
    }

    function deleteArtCollaborator (sArtId, iUserId) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_UNSHARE_ART, [sArtId, iUserId])
      return ConnectorWebService.fnDelete(sUrl)
    }

    function resendEmailArtCollaborator (sArtId, iUserId) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ART_RESEND, [sArtId, iUserId])
      return ConnectorWebService.put(sUrl)
    }

    function getArts (sFolderId, iTop, iSkip, status, filterInstagram) {
      var sUrl = CONSTANTS.URL_USERS_ARTS

      if (sFolderId !== undefined && sFolderId !== null) {
        sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_FOLDERS_ARTS, [sFolderId])
      }

      if (iTop || iSkip) {
        sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
      }

      if (status) {
        sUrl = Utils.fnAddQueryToUrl(sUrl, { status })
      }

      if (filterInstagram) {
        sUrl = Utils.fnAddQueryToUrl(sUrl, { filterInstagram })
      }

      return ConnectorWebService.get(sUrl)
    }

    function copyArtUrlToClipboard (artId) {
      const artUrl = getUrlForArtId(artId)

      return navigator.clipboard.writeText(artUrl)
    }

    function getUrlForArtId (artId) {
      const companyBaseUrl = CustomerCompanyService.getCompanyBaseUrl()
      const assetsModuleBaseUrl = `${companyBaseUrl}/arts/templates`

      return Utils.fnAddQueryToUrl(assetsModuleBaseUrl, {
        previewId: artId
      })
    }

    function getArtsApprovals (iTop, iSkip, oFilters = {}, sort, search) {
      let sUrl = Utils.fnAddTopSkipQueriesToUrl(CONSTANTS.URL_ARTS_APPROVALS, iTop, iSkip)
      sUrl = Utils.fnAddQueryToUrl(sUrl, {
        approvalStatus: oFilters.statusFilter,
        userId: oFilters.userId,
        groupId: oFilters.groupId,
        periodStart: oFilters.initialDate && oFilters.initialDate.startOf('dat').toISOString(),
        periodEnd: oFilters.endDate && oFilters.endDate.endOf('day').toISOString(),
        productId: oFilters.productId,
        $sort: sort.name,
        $order: sort.order,
        search,
        isArchived: oFilters.isArchived,
        customizationLevel: oFilters.customizationLevel,
        needApproval: oFilters.needApproval,
        artTagIds: oFilters.artTagIds,
        formatId: oFilters.formatId,
        createdAt: oFilters.createdAt,
        templateExpiration: oFilters.templateExpiration,
        ownerId: oFilters.ownerId
      })

      return ConnectorWebService.get(sUrl)
    }

    function deleteArt (sArtId) {
      if (sArtId === undefined) {
        throw new Error("'Art ID' cannot be null on 'deleteArt' function")
      }
      return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID, [sArtId]))
    }

    function findLayersId (sArtId) {
      if (sArtId === undefined) {
        throw new Error("'Art ID' cannot be null on 'deleteArt' function")
      }
      return ConnectorWebService.get(Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_LAYERS_ID, [sArtId]))
    }

    function getArtDetailById (sArtId) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID_DETAILS, [sArtId])
      return ConnectorWebService.get(sUrl)
    }

    function updateArtById (sArtId, oData) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID, [sArtId])
      return ConnectorWebService.put(sUrl, oData)
    }

    function deleteArts (aArtsId) {
      if (aArtsId === undefined || aArtsId.length === 0) {
        throw new Error("'Array of Arts ID' cannot be null on 'deleteArts' function")
      }
      return ConnectorWebService.put(CONSTANTS.URL_ARTS_BATCH_DELETE, { artIds: aArtsId })
    }

    function getUserFolders () {
      return ConnectorWebService.get(CONSTANTS.URL_USERS_FOLDERS)
    }

    function createFolder (oFolder) {
      return ConnectorWebService.post(CONSTANTS.URL_FOLDERS, oFolder)
    }

    function updateFolder (sFolderId, oFolder) {
      if (sFolderId === undefined) {
        throw new Error("'Folder ID' cannot be null on 'updateFolder' function")
      }
      return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_FOLDERS_ID, [sFolderId]), oFolder)
    }

    function deleteFolder (sFolderId) {
      if (sFolderId === undefined) {
        throw new Error("'Folder ID' cannot be null on 'deleteFolder' function")
      }
      return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_FOLDERS_ID, [sFolderId]))
    }

    function setArtsFolder (folderId, artIds) {
      if (artIds === undefined || folderId === undefined) {
        throw new Error("'Art IDs' and 'Folder ID' cannot be null on 'setArtsFolder' function")
      }
      return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_SET_FOLDER, [folderId]), { artIds })
    }

    function removeArtsFromFolder (artIds) {
      if (artIds === undefined) {
        throw new Error("'Art IDs' cannot be null on 'removeArtsFromFolder' function")
      }
      return ConnectorWebService.put(CONSTANTS.URL_ARTS_REMOVE_FOLDER, { artIds })
    }

    function cloneArt (sArtId) {
      if (sArtId === undefined) {
        throw new Error("'Art ID' cannot be null on 'cloneArt' function")
      }
      return ConnectorWebService.post(Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DUPLICATE, [sArtId]))
    }

    function getArtCategoriesByProduct (iProductId, iTop, iSkip) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_CATEGORIES_PRODUCT_ID, [iProductId])

      if (iTop || iSkip) {
        sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
      }

      return ConnectorWebService.get(sUrl)
    }

    function getArtApprovalComments (iArtId, iTop, iSkip) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_APPROVAL_COMMENTS, [iArtId])

      if (iTop || iSkip) {
        sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
      }

      return ConnectorWebService.get(sUrl)
    }

    function getArtApprovalHistory (iArtId, iTop, iSkip) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_APPROVAL_HISTORY, [iArtId])

      if (iTop || iSkip) {
        sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
      }

      return ConnectorWebService.get(sUrl)
    }

    function getUserTemplates (iTop, iSkip) {
      var sUrl = CONSTANTS.URL_USERS_TEMPLATES

      if (iTop || iSkip) {
        sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
      }

      return ConnectorWebService.get(sUrl)
    }

    function getCompanyTemplates (top, skip, filters, sort, search, startFromId, previewSort, templatesIds, viewType) {
      let url = CONSTANTS.URL_TEMPLATES

      if (filters) {
        url = Utils.fnAddQueryToUrl(url, filters)
      }

      if (sort) {
        url = Utils.fnAddQueryToUrl(url, { $sort: sort.name, $order: sort.order })
      }

      if (search) {
        url = Utils.fnAddQueryToUrl(url, { term: search })
      }

      if (top || skip) {
        url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      }

      if (startFromId && previewSort) {
        url = Utils.fnAddQueryToUrl(url, { startFromId, previewSort })
      }

      if (viewType) {
        url = Utils.fnAddQueryToUrl(url, { viewType })
      }

      if (templatesIds?.length) {
        templatesIds.forEach(templateId => {
          url = Utils.fnAddQueryToUrl(url, { templatesIds: templateId })
        })
      }

      return ConnectorWebService.get(url)
    }

    function deleteArtLayer (sArtId, sLayerId) {
      return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_LAYER_ID, [sArtId, sLayerId]))
    }

    function search (term, top, skip, filters, startFromId, previewSort) {
      let url = CONSTANTS.URL_TEMPLATES_SEARCH
      url = Utils.fnAddQueryToUrl(url, { term })
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)

      if (filters) {
        const { formatId, customizationLevel, needApproval, groupId, createdAt, templateExpiration, isArchived, artTagIds, createdAtStart, templateExpirationStart, createdAtEnd, templateExpirationEnd, campaignId } = filters

        url = Utils.fnAddQueryToUrl(url, { formatId, customizationLevel, needApproval, groupId, createdAt, templateExpiration, isArchived, startFromId, previewSort, createdAtStart, templateExpirationStart, createdAtEnd, templateExpirationEnd, campaignId })
        url = Utils.addQueryStringFromArray(url, 'artTagIds', artTagIds)
      }

      return ConnectorWebService.get(url)
    }

    function formatApprovalStatusText (sStatus) {
      switch (sStatus) {
        case 'DESIGNING':
          return $translate.instant('needToSendApproval')
        case 'PENDING_APPROVAL':
          return $translate.instant('waitingApproval')
        case 'PENDING_REWORK':
          return $translate.instant('adjustmentsNeeded')
        case 'APPROVED':
          return $translate.instant('approved')
        case 'REJECTED':
          return $translate.instant('reproved')
        default:
          return ''
      }
    }

    function renderArt (id, options) {
      const body = {
        fileFormat: options.fileFormat,
        separateFiles: options.separateFiles
      }

      if (options.videoPreview) {
        body.videoPreview = options?.videoPreview
      }

      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_RENDER_ID, [id])

      return ConnectorWebService.post(url, body)
    }

    function downloadArt (id, fileFormat, originalExtension) {
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DOWNLOAD, [id])
      url = Utils.fnAddQueryToUrl(url, { fileFormat, originalExtension })

      return Utils.downloadFile(url, {
        artId: id
      })
    }

    function updateArtSize (id, newArtSizeId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_UPDATE_ART_SIZE, [id])
      return ConnectorWebService.put(url, { newArtSizeId })
    }

    function updateComment (id, options) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_APPROVAL_COMMENTS, [id])
      return ConnectorWebService.put(url, options)
    }

    function deleteComment (artId, commentId) {
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_APPROVAL_COMMENTS, [artId])
      url = Utils.fnAddQueryToUrl(url, { commentId })
      return ConnectorWebService.fnDelete(url)
    }

    function getArtPins (artId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_PINS, [artId])
      return ConnectorWebService.get(url)
    }

    function getSocialSharingLog (artId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID_SOCIALSHARING, [artId])
      return ConnectorWebService.get(url)
    }

    function bulkArchiveTemplates (templates) {
      return ConnectorWebService.put(CONSTANTS.URL_ARTS_ARCHIVE_BATCH, { templates })
    }

    function bulkUnarchiveTemplates (templates, turnArtsAvailable = false) {
      return ConnectorWebService.put(CONSTANTS.URL_ARTS_UNARCHIVE_BATCH, { templates, turnArtsAvailable })
    }

    function bulkUpdateTemplates (payload) {
      return ConnectorWebService.put(CONSTANTS.URL_ARTS_SETTINGS_BATCH, { templates: payload })
    }

    function getBusinessDataByArt (artId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID_BUSINESSDATA, [artId])
      return ConnectorWebService.get(url)
    }

    function canShareArt (artId) {
      return service.getBusinessDataByArt(artId).then(artBdf => {
        return !artBdf.length
      })
    }

    function archiveTemplatesByCampaign (campaignId) {
      return ConnectorWebService.put(CONSTANTS.URL_TEMPLATES_ARCHIVE_CAMPAIGN, { id: campaignId })
    }

    function unarchiveTemplatesByCampaign (campaignId) {
      return ConnectorWebService.put(CONSTANTS.URL_TEMPLATES_UNARCHIVE_CAMPAIGN, { id: campaignId })
    }

    function getPhotoframesByArtAndId (id, svgId) {
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_PHOTOFRAMES_ART_ID_SVG_ID, [id])

      url = Utils.fnAddQueryToUrl(url, { svgId })

      return ConnectorWebService.get(url)
    }

    function getPhotoframeAssets (id, top, skip, filters) {
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_PHOTOFRAMES_ART_ID_ASSETS, [id])

      if (top || skip) {
        url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
      }

      if (filters?.search) {
        url = Utils.fnAddQueryToUrl(url, { search: filters.search })
      }

      if (filters?.brandSectionCategoryId) {
        url = Utils.fnAddQueryToUrl(url, { brandSectionCategoryId: filters.brandSectionCategoryId })
      }

      if (filters?.brandSectionId) {
        url = Utils.fnAddQueryToUrl(url, { brandSectionId: filters.brandSectionId })
      }

      if (filters?.allowAllVideos) {
        url = Utils.fnAddQueryToUrl(url, { allowAllVideos: filters.allowAllVideos })
      }

      if (filters?.allowAllImages) {
        url = Utils.fnAddQueryToUrl(url, { allowAllImages: filters.allowAllImages })
      }

      return ConnectorWebService.get(url)
    }

    function getPhotoframeAssetsCountByCategory (id, filters) {
      let url = Utils.fnReplaceStringParams(CONSTANTS.URL_PHOTOFRAMES_ART_ID_ASSETS_COUNT, [id])

      if (filters?.brandSectionId) {
        url = Utils.fnAddQueryToUrl(url, { brandSectionId: filters.brandSectionId })
      }

      if (filters?.brandSectionCategoryId) {
        url = Utils.fnAddQueryToUrl(url, { brandSectionCategoryId: filters.brandSectionCategoryId })
      }

      return ConnectorWebService.get(url)
    }

    function preventUploadWebp (assets, index, showMessage, fnSuccess, fnError, fnProgress, fnCancel, fnUpload) {
      const upload = () => fnUpload()

      const reader = new FileReader()
      reader.onloadend = function (event) {
        const image = event.target.result

        const arr = (new Uint8Array(image)).subarray(0, 4)
        let header = ''
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16)
        }

        if (header === '52494646') { // webp code
          const i = assets.findIndex(a => a === assets[index])
          if (i !== -1) {
            assets.splice(i, 1)
            index--
            showMessage = true
          }
        }

        if (assets.length - 1 > index) {
          service.preventUploadWebp(assets, ++index, showMessage, fnSuccess, fnError, fnProgress, fnCancel, fnUpload)
        } else {
          if (showMessage) {
            MessageService.warning({
              title: $translate.instant('uploadWebpMessage.title'),
              text: $translate.instant('uploadWebpMessage.text'),
              confirmButton: $translate.instant('ok'),
              closeOnConfirm: true,
              press () {
                if (assets.length) {
                  upload()
                } else {
                  fnCancel()
                }
              }
            })
          } else {
            upload()
          }
        }
      }
      reader.readAsArrayBuffer(assets[index])
    }

    function uploadAssets (files, fnSuccess, fnError, fnProgress) {
      UploadService.uploadWithCustomProgress(
        CONSTANTS.URL_USERS_ME_IMAGES,
        files,
        {
          fnSuccess,
          fnError,
          fnProgress
        },
        { simultaneousLimit: 5, allFiles: files },
        {}
      )
    }

    function getPhotoframesCount (artId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PHOTOFRAMES_ART_ID_COUNT, [artId])

      return ConnectorWebService.get(url)
    }

    function updateArtSection (sectionId, payload) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_SECTION_ID, [sectionId])

      return ConnectorWebService.put(url, payload)
    }

    function getHyperlinksByArt (artId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID_HYPERLINKS, [artId])

      return ConnectorWebService.get(url)
    }

    function getInfosBusinessData (sArtId) {
      var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_BUSINESS_HAS_UPDATE, [sArtId])
      return ConnectorWebService.get(sUrl)
    }

    function updateTemporarilyAvailableArt (artId, payload) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID_TEMPORARILY_AVAILABLE, [artId])

      return ConnectorWebService.put(url, payload)
    }

    function getDefaultAssetsForPhotoframe (brandSectionId, filters) {
      const { brandSectionCategoryId, search, $top = 100, $skip = 0 } = filters
      let url = Utils.fnAddQueryToUrl(CONSTANTS.URL_PHOTOFRAMES_ASSETS_DEFAULT, { brandSectionId })

      if (brandSectionCategoryId) {
        url = Utils.fnAddQueryToUrl(url, { brandSectionCategoryId })
      }

      if (search) {
        url = Utils.fnAddQueryToUrl(url, { search })
      }

      if ($top || $skip) {
        url = Utils.fnAddQueryToUrl(url, { $top, $skip })
      }

      return ConnectorWebService.get(url)
    }

    function updateArtSettings (artId, payload) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ARTID_SETTINGS, [artId])

      if (window.__DeskfyObserver__) {
        window.__DeskfyObserver__[`template-${artId}`] = payload.name
      }

      return ConnectorWebService.put(url, payload)
    }

    function getArtSettings (artId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ARTID_SETTINGS, [artId])

      return ConnectorWebService.get(url)
    }

    function uploadTemplates (payload) {
      const url = CONSTANTS.URL_ARTS_UPLOAD_TEMPLATES
      return ConnectorWebService.post(url, payload)
    }

    function getMultipleArtsSettings (templateIds) {
      let url = CONSTANTS.URL_ARTS_SETTINGS_MULTIPLE

      if (templateIds?.length) {
        templateIds.forEach(templateId => {
          url = Utils.fnAddQueryToUrl(url, { templatesIds: templateId })
        })
      }

      return ConnectorWebService.get(url)
    }

    function getArtThumbnailUrl (artId) {
      return Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_THUMBNAIL_ID, [artId])
    }

    function bindTemplateToCampaign (params = {}) {
      const { assetId, selectedCampaign } = params

      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID_BIND_CAMPAIGN, [assetId])
      return ConnectorWebService.put(url, { campaignId: selectedCampaign })
    }

    function unbindTemplateFromCampaign (assetId) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_ID_UNBIND_CAMPAIGN, [assetId])
      return ConnectorWebService.put(url)
    }

    function getRecentTemplates (filters) {
      const { $top, $skip, $orderBy, startDate, customizationLevel, needApproval, formatIds, query, tagIds } = filters
      let url = CONSTANTS.URL_USERS_LATEST_TEMPLATES

      if ($top) url = Utils.fnAddQueryToUrl(url, { $top })
      if ($skip) url = Utils.fnAddQueryToUrl(url, { $skip })
      if (query) url = Utils.fnAddQueryToUrl(url, { query })
      if (startDate) url = Utils.fnAddQueryToUrl(url, { startDate })
      if (tagIds?.length) url = Utils.addQueryStringFromArray(url, 'tagIds', tagIds)
      if (formatIds?.length) url = Utils.addQueryStringFromArray(url, 'formatIds', formatIds)
      if (typeof needApproval !== 'undefined') url = Utils.fnAddQueryToUrl(url, { needApproval: +needApproval })
      if (Array.isArray(customizationLevel) && customizationLevel.length) url = Utils.addQueryStringFromArray(url, 'customizationLevel', customizationLevel)

      if (Array.isArray($orderBy) && $orderBy.length) {
        url = Utils.addQueryStringFromArray(url, '$orderBy', $orderBy.map(order => order.field))
        url = Utils.addQueryStringFromArray(url, '$orderType', $orderBy.map(order => order.type))
      }

      return ConnectorWebService.get(url)
    }

    function batchDownloadMaterials (artIds, artCollectionIds, fileFormat, originalExtension) {
      let url = CONSTANTS.URL_ARTS_BATCH_DOWNLOAD

      if (artIds) {
        url = Utils.fnAddQueryToUrl(url, { artIds })
      }

      if (artCollectionIds) {
        url = Utils.fnAddQueryToUrl(url, { artCollectionIds })
      }

      if (fileFormat) {
        url = Utils.fnAddQueryToUrl(url, { fileFormat })
      }

      if (originalExtension) {
        url = Utils.fnAddQueryToUrl(url, { originalExtension })
      }

      return Utils.downloadFile(url)
    }

    function batchRenderMaterials (artIds, fileFormat) {
      const url = CONSTANTS.URL_ARTS_BATCH_RENDER

      const body = {
        artIds
      }

      if (fileFormat) {
        body.fileFormat = fileFormat
      }

      return ConnectorWebService.post(url, body)
    }
  }
})()
